import {useNavigate} from "react-router-dom"
import ProjectTag from "../project-tag/ProjectTag"
import ProjectLangTag from "../project-lang-tag/ProjectLangTag"
import ParseDate from "../../tools/ParseDate"
import docsIcon from "../../assets/icon/docs.svg"
import videoFileIcon from "../../assets/icon/video-file.svg"
import audioIcon from "../../assets/icon/audio.svg"
import downloadIcon from "../../assets/icon/download.svg"
import ProfilePicture from "../profile-picture/ProfilePicture"
import useTries from "../../swrCustomHooks/useTries"
import trashIcon from "../../assets/icon/trash.svg"
import replayIcon from "../../assets/icon/replay.svg"
import progressIcon from "../../assets/icon/progress.svg"
import axios from "axios"
import {API_PROJECTS} from "../../constants/apiUrls"
import {useTranslation} from "react-i18next"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"
import isLicenceValidity from "../../tools/isLicenceValidity"
import {toast} from "react-toastify"
import parseTries from "../../tools/parseTries"

export default function ProjectCard({project, type, tab}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {setStProjectsAction} = useStProjectsContext()
    const {setEcpProjectsAction} = useEcpProjectsContext()
    const {tries, isLoadingTries, isErrorTries} = useTries(project.id)
    const trie = parseTries(tries || [])
    const navigate = useNavigate()

    const selectProject = (e) => {
        e.stopPropagation()
        navigate(`/${type}/workflow/${project.id}`)
    }

    const downloadProject = (e) => {
        e.stopPropagation()
        const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
        axios.get(`${API_PROJECTS}/${project.id}/archive.zip`, headersRequest, {maxRedirects: 0})
        .then((response) => {
            var link = document.createElement("a")
            link.href = response.data
            link.click()
        })
        .catch((error) => {
            console.error("GET /project/archive.zip: ", error)
        })
    }

    const deleteProject = (e) => {
        e.stopPropagation()
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            type === "st" ? setStProjectsAction({type: "ST_PROJECTS_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: true, id: project.id, action: "delete"}}})
            : setEcpProjectsAction({type: "ECP_PROJECTS_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: true, id: project.id, action: "delete"}}})
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    const restoreProject = (e) => {
        e.stopPropagation()
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            type === "st" ? setStProjectsAction({type: "ST_PROJECTS_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: true, id: project.id, action: "restore"}}})
            : setEcpProjectsAction({type: "ECP_PROJECTS_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: true, id: project.id, action: "restore"}}})
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    if (!project.owner || isErrorTries || isLoadingTries || tries.message) return null
    return (
        <>
        <div className="project-card" onClick={tab !== "recycle-bin" ? selectProject : () => {}}>
            <img className="file" src={project.file_type === "video" ? videoFileIcon : project.file_type === "audio" ? audioIcon : docsIcon} alt=""/>
            <p className="name" title={project.title}>{project.title}</p>
            {type === "ecp" &&
                <ProjectLangTag tag={project.lang_code}/>
            }
            <div className="tag">
                <ProjectTag tag={project.deleted ? "delete" : project.finished ? "finished" : trie.step}/>
            </div>
            <div className="tag">
                <ProjectTag tag={project.deleted ? "private" : project.is_public ? "public" : "private"}/>
            </div>
            <p className="date">{ParseDate(project.created_at)}</p>
            <ProfilePicture idUser={project.owner.id}/>
            <p className="username" title={`${project.owner.firstname} ${project.owner.lastname}`}>{`${project.owner.firstname} ${project.owner.lastname}`}</p>
            <div className="actions">
                {project.ongoing_process ?
                    <img className="run" src={progressIcon} alt=""/>
                    :
                    <>
                    {(project.archive_status === "done" && project.finished) && tab !== "recycle-bin" && <><img className="download" src={downloadIcon} alt="" onClick={downloadProject} title={t("Export")}/></>}
                    {tab === "recycle-bin" ?
                        <img className="restore" src={replayIcon} alt="" onClick={restoreProject} title={t("Restore")}/>
                        :
                        <>{project.owner.id === sessionContext.idUser && <img className="delete" src={trashIcon} alt="" onClick={deleteProject} title={t("Delete")}/>}</>
                    }
                    </>
                }
            </div>
        </div>
        </>
    )
}